// Schemas
export const TEALIUM_SCHEMA_MODAL_OPEN =
  'iglu:au.com.realestate/my_rea_modal_open/jsonschema/2-0-4';
